var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visibleStatus ? _c('div', {
    staticClass: "modalPopup-wrap"
  }, [_c('div', {
    staticClass: "contentWrap"
  }, [_c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.type !== 'edit',
      expression: "type !=='edit'"
    }],
    staticClass: "title"
  }, [_vm._v("항목 추가하기")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.type === 'edit',
      expression: "type==='edit'"
    }],
    staticClass: "title editButtons"
  }, [_c('button', {
    staticClass: "edit",
    on: {
      "click": function ($event) {
        _vm.disabled = false;
      }
    }
  }, [_vm._v("수정하기")]), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.tagInfoDelete
    }
  }, [_vm._v("삭제하기")])]), _c('div', {
    staticClass: "content"
  }, [_c('ValidationText', {
    attrs: {
      "status": _vm.tagTitle === '',
      "addClass": "name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tagTitle,
      expression: "tagTitle"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "placeholder": "항목을 추가해 주세요"
    },
    domProps: {
      "value": _vm.tagTitle
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.tagTitle = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "desc"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tagContent,
      expression: "tagContent"
    }],
    attrs: {
      "readonly": _vm.disabled,
      "edita": "",
      "name": "",
      "id": "",
      "cols": "",
      "rows": "",
      "placeholder": "내용을 입력해 주세요"
    },
    domProps: {
      "value": _vm.tagContent
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.tagContent = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "images"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.imageUrl && !_vm.disabled,
      expression: "!imageUrl && !disabled"
    }],
    attrs: {
      "for": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.imageUpload
    }
  }), _vm._v(" 이미지 추가하기 ")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl,
      expression: "imageUrl"
    }],
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  }), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl,
      expression: "imageUrl"
    }],
    staticClass: "imageDelete",
    on: {
      "click": _vm.imageDelete
    }
  }, [_vm._v("이미지 삭제")])])])], 1), _c('div', {
    staticClass: "ctrl buttons"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.type === 'edit' && _vm.disabled == false,
      expression: "type==='edit' && disabled==false"
    }],
    staticClass: "confirm",
    on: {
      "click": _vm.merge
    }
  }, [_vm._v("수정하기")]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.type !== 'edit',
      expression: "type!=='edit'"
    }],
    staticClass: "confirm",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("생성하기")])]), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("취소")])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }